import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { SharedOrderService } from '../../../../core/services/shared-order.service';
import { Restaurant } from '../../../../core/models/restaurant.model';
import { CreateSharedOrder, SharedOrderResponse } from '../../../../core/models/shared-order.model';
import { environment } from '../../../../../environments/environment';
import { PaymentStore } from '../../../../core/stores/payment.store';
import {UrlParam} from '../../../../core/enums/group-param.enum';
import {CartStore} from '../../../../core/stores/cart.store';
import {SharedOrderText} from '../../../../core/enums/shared-order.enum';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-shared-orders-modal',
  templateUrl: './shared-orders-modal.component.html',
  styleUrls: ['./shared-orders-modal.component.scss'],
})
export class SharedOrdersModalComponent implements OnInit, OnDestroy {
  public restaurant: Restaurant =  new Restaurant();
  public sharedOrder: boolean;
  public shareQrLink: string;
  public sharedCreated: boolean;
  public isLoading: boolean;
  public sharedOrderText = SharedOrderText;
  private destroyed$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sharedOrderService: SharedOrderService,
    private paymentStore: PaymentStore,
    public dialogRef: MatDialogRef<SharedOrdersModalComponent>,
    private cartStore: CartStore
  ) { }

  ngOnInit() {
    this.initData();
    this.getTabs();
  }
  ngOnDestroy() {
    this.destroyed$.complete();
    this.destroyed$.next();
  }

  public removeSharedOrder(): void {
    this.sharedOrderService.clearSharedOrder();
    this.dialogRef.close();
  }

  public copySharedUrl(): void {
    const textarea = document.createElement('textarea');
    textarea.value = this.shareQrLink;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  }

  public createSharedOrder(): void {
    if (this.sharedCreated) {
      this.dialogRef.close();
      return;
    }
    this.isLoading = true;
    const sharedBody = new CreateSharedOrder();
    if (this.restaurant.enableSharedOrderSingleOrderReceivedSms) {
      sharedBody.phone_number = this.paymentStore.phoneNumber;
    }
    this.sharedOrderService.createSharedOrder(this.restaurant.locationId, sharedBody)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((sharedOrder: SharedOrderResponse) => {
        this.shareQrLink = environment.apiUrl + `shared-orders/${sharedOrder.sharedOrderId}`;
        sessionStorage.setItem(UrlParam.sharedOwnerId, sharedOrder.sharedOrderId);
        this.sharedOrderService.sharedOwnerId$ = sharedOrder.sharedOrderId;
        this.sharedCreated = true;
        this.isLoading = false;
      }, () => {
        this.isLoading = false;
      });
  }
  private getTabs(): void {
    this.cartStore.tab$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(tab => {
      if (tab) {
        this.dialogRef.close();
      }
    });
  }

  private initData(): void {
    if (this.data && this.data.restaurant) {
      this.restaurant = this.data.restaurant;
    }
    if (this.data && this.data.isView) {
      this.sharedOrder = true;
      this.sharedCreated = true;
      this.shareQrLink = environment.apiUrl + `shared-orders/${this.sharedOrderService.sharedOwnerId$}`;
    }
  }
}
